exports = module.exports = require("../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v-modal-enter{animation:v-modal-in .2s ease}.v-modal-leave{animation:v-modal-out .2s ease forwards}@keyframes v-modal-in{0%{opacity:0}}@keyframes v-modal-out{to{opacity:0}}.v-modal{position:fixed;left:0;top:0;width:100%;height:100%;opacity:.5;background:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader!./src/utils/vue-popup/popup.css
// module id = 470
// module chunks = 0